import axios, { AxiosError, AxiosResponse } from 'axios';

export async function getResponseData<TData>(promise: Promise<AxiosResponse<TData>>): Promise<TData> {
	const response = await promise;
	return response.data;
}

export async function getApiResponseData<T>(
	promise: Promise<AxiosResponse<T>>
): Promise<{ data: T | null; error: AxiosError | null }> {
	try {
		const response = await promise;
		return { data: response.data, error: null };
	} catch (error) {
		if (axios.isAxiosError(error)) {
			returnCustomError(error);
		}

		throw new Error(`Unexpected error: ${error}`);
	}
}

export async function copyTextToClipboard(text: any) {
	try {
		await navigator.clipboard.writeText(text);
	} catch (err) {
		console.error('Failed to copy text to clipboard:', err);
	}
}

export function returnCustomError(error: AxiosError): never {
	if (error.response) {
		const status = error.response.status;
		const statusText = error.response.statusText;
		const data = error.response.data;
		const dataText = JSON.stringify(data);

		if (data && dataText !== '') {
			throw new Error(data);
		}

		copyTextToClipboard(error.response.config.url);

		if (status === 400) {
			throw new Error(`Bad Request: ${statusText} - ${error.response.config.url}`);
		} else if (status === 401) {
			throw new Error(`Unauthorized: ${statusText} - ${error.response.config.url}`);
		} else if (status === 403) {
			throw new Error(`Forbidden: ${statusText} - ${error.response.config.url}`);
		} else if (status === 404) {
			throw new Error(`Not Found: ${statusText} - ${error.response.config.url}`);
		} else if (status == 405) {
			throw new Error(`Method Not Allowed: ${statusText} - ${error.response.config.url}`);
		} else if (status >= 500) {
			throw new Error(`Server Error: ${error.response.config.url}`);
		}

		throw new Error(`API Error: ${status} - ${statusText} - ${error.response.config.url}`);
	}

	throw new Error(`Unknown Error: ${error.message}`);
}

export function getErrorData<TData = any>(response: unknown): TData | undefined {
	return (response as AxiosError<TData>).response?.data;
}

export function getErrorStatus<TData = any>(response: unknown): number | undefined {
	return (response as AxiosError<TData>).response?.status;
}
